(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["getintouch"]) return;
  try {
    
  document.querySelectorAll('.material-field').forEach(function (element) {
    element.addEventListener('focusout', function () {
      if (this.value !== "") {
        this.closest('li').classList.add('notempty');
      } else {
        this.closest('li').classList.remove('notempty', 'focused');
      }
    });
  });

  document.getElementById('saveForm').addEventListener('click', function () {
    //validateGetInTouch();
  });

  function validateGetInTouch() {
    var nameReg = /^[A-Za-z]+$/;
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;

    var names = document.getElementById('Field1');
    var email = document.getElementById('Field9');
    var message = document.getElementById('Field7');

    var isValid = true;

    if (names.value === "") {
      isValid = false;
      names.closest('li').classList.add('error', 'notempty');
    } else {
      names.closest('li').classList.remove('error');
    }

    if (email.value === "") {
      isValid = false;
      email.closest('li').classList.add('error', 'notempty');
    } else if (!emailReg.test(email.value)) {
      isValid = false;
      email.closest('li').classList.add('error', 'notempty');
    } else {
      email.closest('li').classList.remove('error');
    }

    if (message.value === "") {
      isValid = false;
      message.closest('li').classList.add('error', 'notempty');
    } else {
      message.closest('li').classList.remove('error');
    }

    //alert('novalidate');
    return isValid;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const body = document.body;
  const tabLists = document.querySelectorAll(".tab-lists li");
  const tabPanels = document.querySelectorAll(".tab-contents .tab-panel");

  // Set initial active tab based on 'vip' class
  if (body.classList.contains("vip")) {
      tabLists[1].classList.add("active");
      tabPanels[1].classList.add("active");
  } else {
      tabLists[0].classList.add("active");
      tabPanels[0].classList.add("active");
  }

  // Add click event listener to tab items
  document.querySelectorAll(".tab-lists li a").forEach(tab => {
      tab.addEventListener("click", function (event) {
          if(this.dataset.href) {
            location.href= this.dataset.href;
          }
          event.preventDefault();

          // Remove 'active' class from all tabs and panels
          tabLists.forEach(li => li.classList.remove("active"));
          tabPanels.forEach(panel => panel.classList.remove("active"));

          // Add 'active' class to clicked tab
          this.parentElement.classList.add("active");

          // Activate the corresponding tab panel
          const section = this.getAttribute("data-section");
          const targetPanel = document.querySelector(`.tab-contents .tab-panel[data-section="${section}"]`);
          if (targetPanel) {
              targetPanel.classList.add("active");
          }
      });
  });

  const em = "{{customer.email}}";
  const statuses = {
      0: 'Pending',
      1: 'Accepted as Lost/Broken',
      2: 'Accepted as Craftsmanship',
      3: 'Rejected',
      4: 'Accepted as RX Replacement',
  };

  const API_URL = 'https://twilight-flowers-hlgyuddy7tc5.vapor-farm-g1.com/api/manual_replacements/';

  if (em) {
      fetch(API_URL + btoa(em) + "/recent")
          .then(response => response.json())
          .then(data => {
              const requests = data.data;
              const noRequestsDiv = document.querySelector('div[data-id="no-replacement-requests"]');
              const requestsTable = document.querySelector('table[data-id="replacement-requests"]');
              const tableBody = requestsTable.querySelector("tbody");

              if (!requests.length) {
                  noRequestsDiv.innerHTML = "You don't have any replacement in the last 60 days";
                  noRequestsDiv.style.display = "flex";
                  requestsTable.style.display = "none";
              } else {
                  requests.forEach((request, index) => {
                      const row = document.createElement("tr");
                      row.className = index % 2 ? "even" : "odd";
                      row.innerHTML = `
                          <td>#${request.ticket_id}</td>
                          <td><span class="note">${request.replacement_reason}</span></td>
                          <td><span class="note">${statuses[request.status]}</span></td>
                      `;
                      tableBody.appendChild(row);
                  });

                  requestsTable.style.display = "table";
                  noRequestsDiv.style.display = "none";
              }
          })
          .catch(error => console.error("Error fetching replacement requests:", error));
      }
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
